module.exports = __webpack_public_path__ + "img/google-play.c567e2dc.svg";